<!--赖传峰-->
<!--2022/4/22-->
<template>
  <div
    :class="[customClass, showIconLink && 'icon-link']"
    class="folder-cover"
  >
    <div class="back" />
    <div class="cover">
      <ElImage
        :alt="name"
        :lazy="lazy"
        :src="src"
        fit="cover"
      >
        <template #placeholder>
          <div class="placeholder" />
        </template>
        <template #error>
          <div :class="src ? 'error' : 'empty'" />
        </template>
      </ElImage>
    </div>
    <div class="front" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from '#imports'

const props = withDefaults(
  defineProps<{
    thumbnailLink?: string
    iconLink?: string
    name: string
    lazy?: boolean
    customClass?: string
  }>(),
  {
    thumbnailLink: undefined,
    iconLink: undefined,
    lazy: true,
    customClass: undefined,
  },
)

const src = computed(() => props.thumbnailLink || props.iconLink)
const showIconLink = computed(() => !props.thumbnailLink && !!props.iconLink)
</script>

<style lang="less">
@import '@/assets/styles/util.less';

.folder-cover {
  position: relative;
  --cover-size: 120px;
  --thumbnail-width: calc(var(--cover-size) * 0.75);
  --thumbnail-height: calc(var(--thumbnail-width) * 9 / 16);
  --frame-width: calc(var(--cover-size) * 0.65);
  --frame-height: 4px;

  width: var(--cover-size);
  height: var(--cover-size);
  transform: scale(1.2);

  &.icon-link {
    .el-image {
      width: 24px;
      height: 24px;
    }
  }

  .back,
  .front {
    position: absolute;
    width: var(--cover-size);
    height: var(--cover-size);
  }

  #cover(@file) {
    @url: '@/assets/images/share/thumbnail-@{file}.svg';
    height: 100%;
    background: url(@url) var(--no-repeat-center) / 30px #e5e7e9;
  }

  .placeholder,
  .empty {
    #cover('placeholder');
  }

  .error {
    #cover('error');
  }

  .cover {
    position: absolute;
    margin-left: 50%;
    margin-top: 3%;
    transform: translate(-50%, 50%);
    width: var(--thumbnail-width);
    height: var(--thumbnail-height);
    background: #e5e7e9;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;

    &:before {
      position: absolute;
      content: '';
      display: block;
      top: 0;
      transform: translate(0, -100%);
      width: var(--frame-width);
      height: var(--frame-height);
      background: #c6cad0;
      border-radius: 4px 4px 0 0;
    }
  }

  .el-image {
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .back {
    background: url('@/assets/images/share/folder-cover-back.svg') var(--no-repeat-center) / 100%;
  }

  .front {
    background: url('@/assets/images/share/folder-cover-front.svg') var(--no-repeat-center) / 100%;
  }
}

@media screen and (max-width: @mobile-break-width) {
  .folder-cover {
    --cover-size: 80px;
    --frame-height: 3px;
  }
}
</style>
